export default __webpack_public_path__ + "static/media/Red Wings.f578a53e.png";